/**
 * Default entity ATIs for Trello (1P).
 */
import type { TrelloEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyTrelloEntityATI = readonly TrelloEntityATI[];

export const DEFAULT_TRELLO_ENTITY_ATI: ReadonlyTrelloEntityATI = [
	'ati:cloud:trello:board',
	'ati:cloud:trello:card',
];
